import { createSelector } from '@ngrx/store';
import * as fromRoot from '../../../store';
import { MailingAddress } from '../../models';
import { cleanAddressId } from '../../services';
import * as fromFeature from '../reducers';
import * as fromAddresses from '../reducers/addresses.reducer';
import { getCustomerDefaultAddress } from './customer.selector';

export const getAddressesState = createSelector(fromFeature.getShopifyState, (state: fromFeature.ShopifyState) => state.addresses);

export const getAddressEntities = createSelector(getAddressesState, fromAddresses.getAddresses);
export const getAddresses = createSelector(getAddressEntities, entities => {
  return Object.keys(entities).map(id => entities[id as unknown as number]) as MailingAddress[];
});

export const getOrderedAddresses = createSelector(getAddresses, getCustomerDefaultAddress, (entities, defaultAddress) => {
  if (defaultAddress) {
    return [
      ...entities.filter(a => a.cleanId === cleanAddressId(defaultAddress.id)),
      ...entities.filter(a => a.cleanId !== cleanAddressId(defaultAddress.id)),
    ];
  } else {
    return entities;
  }
});

export const getAddressesLoadingId = createSelector(getAddressesState, fromAddresses.getAddressesLoadingId);
export const getAddressesLoading = createSelector(getAddressesState, fromAddresses.getAddressesLoading);
export const getAddressesLoaded = createSelector(getAddressesState, fromAddresses.getAddressesLoaded);
export const getAddressesUpdatet = createSelector(getAddressesState, fromAddresses.getAddressesUpdatet);
export const getAddressesErrors = createSelector(getAddressesState, fromAddresses.getAddressesErrors);
export const getAddressesPageInfo = createSelector(getAddressesState, fromAddresses.getAddressesPageInfo);

export const getSelectedAddress = createSelector(getAddresses, fromRoot.getRouterState, (addresses, router) => {
  return router.state && addresses.find(a => cleanAddressId(a.id) === router.state.params['id']);
});
